/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IProofPointData } from './proof-point.data';
import { IProofPointProps } from './proof-point.props.autogenerated';

export interface IProofPointViewProps extends IProofPointProps<IProofPointData> {
    proofPointsNode: React.ReactNode;
}

/**
 *
 * ProofPoint component
 * @extends {React.PureComponent<IProofPointProps<IProofPointData>>}
 */
class ProofPoint extends React.PureComponent<IProofPointProps<IProofPointData>> {
    public render(): JSX.Element | null {
        const viewprops = {
            ...this.props,
            proofPointsNode: this.getProofPointsData()
        };
        return this.props.renderView(viewprops) as React.ReactElement;
    }
    private getProofPointsData(): JSX.Element {
        const { proofPointsImage, proofPointsHeader, proofPointsDescription } = this.props.config;
        const tag = (proofPointsHeader?.tag ?? 'h2') as keyof JSX.IntrinsicElements;
        const Tag = tag;
        return (
            <>
                <>
                    <>
                        <div className='proof-point-card'>
                            <div className='proof-point-icon'>
                                <img src={proofPointsImage?.src} alt={proofPointsImage?.altText} className='icon-image' />
                            </div>
                            <Tag className='proof-point-title'>{proofPointsHeader ? proofPointsHeader.text : ''}</Tag>
                            <Msdyn365.RichTextComponent className='proof-point-description' text={proofPointsDescription ?? ''} />
                        </div>
                    </>
                </>
            </>
        );
    }
}

export default ProofPoint;
